import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxCaptchaModule } from 'ngx-captcha';
import { CaptchaService } from './services';
import { Data } from '@angular/router';

@NgModule({
    imports: [
        NgxCaptchaModule
    ],
    providers: [
        CaptchaService,
    ],
})

export class CaptchaModule {
    public static forConfig(environment: Data): ModuleWithProviders {
        return {
            ngModule: CaptchaModule,
            providers: [
                {
                    provide: 'Environment',
                    useValue: environment,
                },
            ],
        };
    }
}
